import { dashboardTheme } from "../theme/dashboardTheme";

export const fluidFont = (baseRem: number, lgDown: boolean): string => {
  if (!lgDown) return `${baseRem}rem`;
  const min = (baseRem * 0.9).toFixed(3);
  const preferred = (baseRem * 1.35).toFixed(3);
  return `clamp(${min}rem, ${preferred}vw, ${baseRem}rem)`;
};

export const getUserInfoNoDataStyles = (lgDown: boolean) => ({
  divider: {
    width: "100%",
    margin: lgDown ? "0.85rem 0" : "1rem 0",
    borderColor: dashboardTheme.colors.divider,
  },
  buttonMain: {
    marginTop: lgDown ? "0.85rem" : "1rem",
    fontSize: fluidFont(0.9, lgDown),
    padding: lgDown ? "0.64rem 1.28rem" : "0.75rem 1.5rem",
    whiteSpace: "nowrap" as const,
  },
  buttonOutlined: {
    marginTop: lgDown ? "0.85rem" : "1rem",
    fontSize: fluidFont(0.9, lgDown),
    padding: lgDown ? "0.64rem 1.28rem" : "0.75rem 1.5rem",
    whiteSpace: "nowrap" as const,
  },
  accordionTitle: {
    fontSize: fluidFont(1.2, lgDown),
    margin: 0,
    color: dashboardTheme.colors.textPrimary,
    fontWeight: 700,
  },
});
